module.exports = __webpack_public_path__ + "img/um.umd0a77d9.svg";